import { ISbRichtext, renderRichText } from '@storyblok/js';

export const customRenderText = (richText: ISbRichtext) => {
  return renderRichText(richText);
};

export const removeHtml = (str: string) => {
  return str.replace(/<[^>]*>?/gm, '');
};

export const fixHtml = (str: string) => {
  const entities = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
  };
  return str
    .replace(/&amp;/g, '&')
    .replace(/&lt;|&gt;|&quot;|&#39;/g, match => entities[match])
    .replace(/<[^>]*style="[^"]*"[^>]*>/gi, (match: string) => {
      if (match === '<span style="color:#4353FF">') return match;
      if (match === '<span style="color:#FB4F4F">') return match;
      return '';
    })
    .replace(/<p>([<b>]{0,3})<(ul|ol|p)>/g, '$1<$2>')
    .replace(/<\/(ul|ol|p)>([</b>]{0,4})<\/p>/g, '</$1>$2');
};
